import {
    getAxiosFulfilledState,
    getFulfilledState,
    getPendingState,
    getRejectedState,
    resetState,
} from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { IDocumentStackItemDto, IFolderOverviewItemDto, IRootOverviewItemDto, isFolder } from '../config/documentConfig'
import { ActionType } from 'redux-promise-middleware'
import { FileDocumentAction, IFileDocumentResponse } from '../config/fileDocumentConfig'
import { FileAction } from '../config/fileConfig'

export interface IFileDocumentState {
    overview: DataPromise<IRootOverviewItemDto>
}

const defaultState: IFileDocumentState = {
    overview: getDataEmptyState<IRootOverviewItemDto>(),
}

export function reduceChildDocuments<S>(state: S, action: IReduxAction, key: string): S {
    // Make a deep copy, so we can't change the state variable directly.
    const root: IRootOverviewItemDto = JSON.parse(JSON.stringify(state[key].data || {}))
    let parents: IFolderOverviewItemDto[] = [root]
    let parent: IFolderOverviewItemDto

        // Traverse through the stack to grab the parent folder by reference to root.
    ;(action as IFileDocumentResponse).stack.forEach((stackItem: IDocumentStackItemDto) => {
        parent = parents
            // Only get the nodes that are a folder.
            .filter(isFolder)
            .find((parent: IFolderOverviewItemDto) => parent.id === stackItem.id)
        // Set the new set of parents that is one level deeper for the next iteration.
        parents = parent ? (parent.children as IFolderOverviewItemDto[]) : []
    })

    if (parent) {
        // This assignment will propagate to root, because parent is a referenced variable.
        parent.children = (action as IFileDocumentResponse).payload.data || []
    }

    return getFulfilledState(state, root, key)
}

export default function reducer(state: IFileDocumentState = defaultState, action: IReduxAction): IFileDocumentState {
    switch (action.type) {
        case `${FileDocumentAction.GetOverview}_${ActionType.Pending}`: {
            return getPendingState(state, 'overview')
        }
        case `${FileDocumentAction.GetOverview}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'overview')
        }
        case `${FileDocumentAction.GetOverview}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'overview')
        }
        case FileDocumentAction.GetOverviewChildren: {
            return reduceChildDocuments(state, action, 'overview')
        }
        case FileAction.ResetCurrent:
        case FileDocumentAction.ResetOverview: {
            return resetState(state, { overview: null })
        }
    }
    return state
}
